import { render, staticRenderFns } from "./OddsButton.vue?vue&type=template&id=9b74c726&"
import script from "./OddsButton.vue?vue&type=script&lang=js&"
export * from "./OddsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports